OrderRenewalModalController.$inject= ['OrderRenewalService', 'OrderRenewalConfig'];
export default function OrderRenewalModalController(OrderRenewalService, OrderRenewalConfig) {
    var ctrl = this;

    ctrl.$onInit = function() {
        ctrl.catalogid = OrderRenewalConfig.catalogid;
    };
 
    ctrl.isSuccess = false;
    ctrl.isProcess = false;
    ctrl.isError = false;

    ctrl.orderrenewal = function() {
        var model  = {};
        var payload = {};

        payload.surename = ctrl.resolve.params.surename;
        payload.patronymicname = ctrl.resolve.params.patronymicname;
        payload.firstname = ctrl.resolve.params.firstname;
 
        model.docid = ctrl.resolve.params.docid;
        model.barcode = ctrl.resolve.params.barcode;
        model.sigla = ctrl.resolve.params.sigla;
        model.payload = JSON.stringify(payload);

        ctrl.isProcess = true;
        OrderRenewalService.save({}, model).$promise.then(function(response) {
            if (response.success) {
                ctrl.response = response;
                ctrl.isSuccess = true;
            } else {
                ctrl.isError = true;
            }
            ctrl.isProcess = false;
        }, function(error) {
            console.log(error);
            ctrl.isError = error;
            ctrl.isProcess = false;
        });
    };


    ctrl.ok = function() {
        ctrl.modalInstance.close(ctrl.content);
    };

    ctrl.cancel = function() {
        ctrl.modalInstance.dismiss("cancel");
    };
}
